__turbopack_context__.v({
  "buttonsAnimation": "Z7Focq_buttonsAnimation",
  "contentAnimation": "Z7Focq_contentAnimation",
  "fadeInUp": "Z7Focq_fadeInUp",
  "headerAnimation": "Z7Focq_headerAnimation",
  "sectionAnimation": "Z7Focq_sectionAnimation",
});
